import React from 'react';

import { GoldenSummaryContent } from './GoldenSummaryContent';
import GoldenSummaryFactsList from './GoldenSummaryFactsList';

export const SummaryViewToggle: React.FC = () => {
  return (
    <>
      <GoldenSummaryFactsList />
      <GoldenSummaryContent />
    </>
  );
};
